<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div :model="dataForm" class="whiteForm">
      <FieldSelect v-model="cashData" :list="cashType" label="账号类型" placeholder="请选择收款账号类型" @change="onCashTypeChange" />
      <van-field
        v-if="dataForm.cashType==='BANK'"
        v-model="dataForm.bankName"
        required
        clearable
        :disabled="isEdit"
        label="银行名称"
        placeholder="请输入银行名称"
      />
      <van-field
        v-if="dataForm.cashType==='BANK'"
        v-model="dataForm.cashAddress"
        required
        clearable
        :disabled="isEdit"
        label="开户行"
        placeholder="请输入开户行名称"
      />
      <van-field
        v-if="dataForm.cashType!=='OFFLINE'"
        v-model="dataForm.cashAccount"
        required
        clearable
        :disabled="isEdit"
        label="账号"
        placeholder="收款账号"
      />
      <van-field
        v-model="dataForm.cashName"
        required
        clearable
        :disabled="isEdit"
        label="姓名"
        placeholder="收款账号姓名"
      />
      <div class="downButton">
        <van-button v-if="dataForm.moneyAccountId!=='0'" :color="GetColorMain()" style="width:100%" type="danger" size="large" :loading="buttonLoading" loading-text="删除中..." @click="deleteBank">删除</van-button>
        <van-button v-if="dataForm.moneyAccountId==='0'" :color="GetColorMain()" style="width:100%" type="danger" size="large" :loading="buttonLoading" loading-text="保存中..." @click="editBank">保存</van-button>
      </div>
    </div>

  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Field, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import FieldSelect from '@/components/FieldSelect'
import { MyNotify, GetEnumList, ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
    TopBar,
    FieldSelect
  },
  data() {
    return {
      titleTop: '',
      title: '管理交易账号',
      backurl: '/pro/bankList',
      cashType: [],
      buttonLoading: false,
      cashData: undefined,
      isEdit: false,
      dataForm: {
        moneyAccountId: 0,
        bankName: '',
        cashAddress: '',
        cashType: '',
        cashAccount: '',
        cashName: '',
        currency: '',
        manageType: 'SYSTEM'
      }
    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.dataForm.moneyAccountId = this.$route.params.id
    if (this.dataForm.moneyAccountId === '0') {
      this.title = '添加交易账号'
      this.isEdit = false
    } else {
      this.title = '管理交易账号'
      this.isEdit = true
      this.initData()
    }
    setTimeout(() => {
      this.cashType = []
      var cashType = GetEnumList('Em_PayType')
      cashType.forEach(item => {
        if (item.value !== 'WECHAT_PAY') {
          this.cashType.push(item)
        }
      })
    }, 100)
    // this.cashType = GetEnumList('Em_PayType')
    // console.log('cashType', this.cashType)
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onCashTypeChange(select) {
      console.log('onCashTypeChange', select)
      this.dataForm.cashType = select.value
    },
    initData() {
      request({
        url: '/Pro/getMoneyAccount',
        method: 'post',
        params: { id: this.dataForm.moneyAccountId }
      }).then(Response => {
        if (!Response.success) {
          return
        }
        this.dataForm = Response.data
        this.cashData = this.dataForm.cashType
      })
    },
    deleteBank() {
      Dialog.confirm({
        title: '删除账号',
        message: '是否要删除这条账号数据',
        cancelButtonText: '取消',
        confirmButtonText: '删除'
      }).then(() => {
        this.buttonLoading = true
        request({
          url: '/Pro/deleteAccount',
          method: 'post',
          params: { id: this.dataForm.moneyAccountId }
        }).then(Response => {
          this.buttonLoading = false
          if (!Response.success) {
            return
          }
          MyNotify('success', '删除账号成功', 2000)
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push(this.backUrl)
        })
      })
    },
    editBank() {
      if (!this.dataForm.cashType) {
        MyNotify('error', '请选择账号类型')
        return
      }
      if (this.dataForm.cashType !== 'OFFLINE') {
        if (this.dataForm.cashAccount.length < 1) {
          MyNotify('error', '请输入收款账号')
          return
        }
      }
      if (this.dataForm.cashName.length < 1) {
        MyNotify('error', '请输入收款账号姓名')
        return
      }
      if (this.dataForm.cashType === 'BANK') {
        if (this.dataForm.bankName.length < 1) {
          MyNotify('error', '请输入银行名称')
          return
        }
        if (this.dataForm.cashAddress.length < 1) {
          MyNotify('error', '请输入开户行名称')
          return
        }
      }
      this.buttonLoading = true
      request({
        url: '/Pro/addMoneyAccount',
        method: 'post',
        data: this.dataForm
      }).then(Response => {
        this.buttonLoading = false
        if (!Response.success) {
          return
        }
        MyNotify('success', '添加成功', 2000)
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push(this.backUrl)
      })
    }
  }
}
</script>

<style scoped>
.whiteForm{
  margin: 1em;
  border-radius: 0.5em;
  overflow: hidden;
}
</style>
